import { render, staticRenderFns } from "./SurveyStatusBadge.vue?vue&type=template&id=96134808"
import script from "./SurveyStatusBadge.vue?vue&type=script&lang=js"
export * from "./SurveyStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports